import { JSX } from 'react';
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    SelectField, SelectInput
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { useGetIndustries } from "../global-hooks/default-system-hooks";

const companyFilters: JSX.Element[] = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="name" source="name" name="name" />,
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminCompanyList: () => JSX.Element = (): JSX.Element => {
    const { loadedIndustries, loadingIndustries } = useGetIndustries();
    return(
        <List
            actions={ <ListActions /> }
            filters={ companyFilters } >
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="name" />
                { (loadingIndustries) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '50%' } } />
                }
                { (!loadingIndustries) &&
                    <SelectField
                        choices={ loadedIndustries }
                        source="industry"
                    />
                }
                { /* One screen per company since 2026-09-10: Show was merged into Edit. */ }
                <EditButton />
            </Datagrid>
        </List>
    );
}